import { WrenchScrewdriverIcon } from '@heroicons/react/24/outline';
import PublicLayout from './PublicLayout';

function ComingSoonPage({ title }) {
  return (
    <PublicLayout>
      <section className="w-full bg-white rounded-lg border border-gray-200 p-10 flex flex-col items-center text-center gap-3">
        <WrenchScrewdriverIcon className="h-10 w-10 text-navy-light" />
        <h2 className="text-xl font-semibold text-gray-900">{title}</h2>
        <p className="text-sm text-gray-500">This page is coming soon. Check back later!</p>
      </section>
    </PublicLayout>
  );
}

export default ComingSoonPage;
